export default [
  {
    path: "controlcenter",
    name: "controlCenter",
    component: () => import("@/views/adminPanel/pages/ecommerce/Ecommerce.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "intellectualProperty",
    name: "intellectualProperty",
    component: () =>
      import(
        "@/views/adminPanel/pages/myAdmin/components/pages/IntellectualProperty.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "notifications",
    name: "notifications",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/components/notifications/Notification.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "google-analytics",
    name: "google-analytics",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/components/analytics/Analytics.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/CMS/menu",
    name: "CMS-menu",
    component: () => import("@/views/adminPanel/pages/CMS/CmsMenu.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/CMS/page",
    name: "CMS-pages",
    component: () => import("@/views/adminPanel/pages/CMS/pages/CMSPages.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/CMS/media",
    name: "CMS-media",
    component: () => import("@/views/adminPanel/pages/CMS/pages/Media.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/CMS/seo",
    name: "CMS-seo",
    component: () => import("@/views/adminPanel/pages/CMS/pages/seo/SEO.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/newproduct",
    name: "ecommerce-Newproduct",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/components/Details.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/myproduct",
    name: "ecommerce-Myproduct",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/components/Product.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/e-commerce/tags",
    name: "ecommerce-Tags",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/components/Tags.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/e-commerce/attributes",
    name: "ecommerce-Attribute",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/attribute/Attribute.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/order-management",
    name: "ecommerce-OrderManagment",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/orderManagement/OrderManagement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/order-returns",
    name: "ecommerce-OrderReturns",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/orderReturns/OrderReturns.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/e-commerce/review",
    name: "ecommerce-review",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/reviews/Reviews.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/coupon-Management",
    name: "ecommerce-CouponManagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/couponManagement/CouponManagement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/e-commerce/addatrributes",
    name: "ecommerce-Addattribute",
    component: () =>
      import(
        "@/views/adminPanel/pages/ecommerce/attribute/components/Attributecol.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/e-commerce/category",
    name: "ecommerce-categories",
    component: () =>
      import("@/views/adminPanel/pages/ecommerce/components/Category.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/user-mgmt/all-users",
    name: "usermanagement",
    component: () =>
      import("@/views/adminPanel/pages/userManagement/UserManagement.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/performance/error-log",
    name: "performance-errorlog",
    component: () =>
      import("@/views/adminPanel/pages/performance/components/ErrorLog.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/performance/application-log",
    name: "application-Log",
    component: () =>
      import(
        "@/views/adminPanel/pages/performance/components/PerformanceTable.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/SMS-templates",
    name: "settings-SMSTemplates",
    component: () =>
      import("@/views/adminPanel/pages/marcom/components/sms/Sms-news.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/Email-templates",
    name: "settings-EmailTemplates",
    component: () =>
      import("@/views/adminPanel/pages/marcom/components/email/Email-news.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/payment-gateway",
    name: "settings-Payment",
    component: () =>
      import("@/views/adminPanel/pages/settings/pages/payment/Payment.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/settings/payment-gateway/success",
    name: "settings-success",
    component: () => import("@/views/adminPanel/pages/payment/Success.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/settings/payment-gateway/failed",
    name: "settings-failed",
    component: () => import("@/views/adminPanel/pages/payment/Failed.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/version",
    name: "settings-version",
    component: () =>
      import("@/views/adminPanel/pages/settings/pages/version/Version.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/templates",
    name: "templates",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/email/Templatepages.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/settings/error-management",
    name: "settings-errormanagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/settings/pages/errormanagement/ErrorMangement.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/admin-management",
    name: "settings-Adminmanagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/configurations/adminmanagement/Adminmanage.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "controlcenter/settings/role-management",
    name: "settings-Rolemanagement",
    component: () =>
      import(
        "@/views/adminPanel/pages/configurations/rolemanagement/components/RolePrac.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  //templatelayout

  {
    path: "controlcenter/templatelayout-1",
    name: "controlcenter-Templatelayout1",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/email/templateSelect2/emaillayout1.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/templatelayout-2",
    name: "controlcenter-Templatelayout2",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/email/templateSelect2/emaillayout2.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/templatelayout-3",
    name: "controlcenter-Templatelayout3",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/email/templateSelect2/emaillayout3.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "controlcenter/templatelayout-4",
    name: "controlcenter-Templatelayout4",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/email/templateSelect2/emaillayout4.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
];
